var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgHuobi = function SvgHuobi(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 32,
    viewBox: "0 0 21 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6113 9.84531C13.6113 5.25845 11.4002 1.30669 9.70655 0.0129613C9.70655 0.0129613 9.58894 -0.0576058 9.58894 0.130573C9.44781 8.9985 4.95504 11.4213 2.46167 14.6439C-3.25427 22.124 2.06179 30.3098 7.47193 31.8152C10.5063 32.662 6.76626 30.3098 6.29581 25.3701C5.73127 19.3719 13.6113 14.8085 13.6113 9.84531Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5751 12.8797C16.5516 12.8562 16.5046 12.8562 16.4575 12.8797C16.4575 12.8797 16.4575 12.8797 16.434 12.9032C16.3399 14.0088 15.1167 16.4081 13.5878 18.5956C8.38934 26.0287 11.3532 29.6041 13.0232 31.5329C13.9877 32.662 13.0232 31.5329 15.446 30.3803C15.6342 30.2862 20.1505 27.887 20.6445 22.4533C21.1385 17.1608 17.7748 13.8441 16.5751 12.8797Z",
    fill: "#059BDC"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHuobi, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/huobi.e1b77909.svg";
export { ForwardRef as ReactComponent };